// extracted by mini-css-extract-plugin
module.exports = {"fbt-drawer__header":"frequently-mobile-bought-together-drawer_fbt-drawer__header__B4Nvi","fbt_body_container":"frequently-mobile-bought-together-drawer_fbt_body_container__nwTuj"};